import axios from "axios";
import { store } from "../redux";
import { logOutUserAction } from "../redux/actions/userActions";
import ACTIVE_SERVER from "./config";

axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.baseURL = `${ACTIVE_SERVER.serverAddress}/api/v1`;
axios.defaults.timeout = 10000;
axios.defaults.timeoutErrorMessage = "Your Request timed out!";
axios.defaults.withCredentials = true;

// AUTH INSTANCE

export const authInstance = axios.create({
    withCredentials: true
});

authInstance.interceptors.request.use(
    (config) => {
        const { userInfo } = store && store.getState().persistedReducer;

        // Set Bearer token for auth requests
        if (userInfo?.accountInfo?.accessToken) {
            config.headers["Authorization"] = `Bearer ${userInfo.accountInfo.accessToken}`;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

authInstance.interceptors.response.use(
    ((res) => {
        return res;
    },
    (response) => {
        const cookies = response.headers;
        return response;
    })
);
// APIs INSTANCE
export const APIsInstance = axios.create({
    withCredentials: true
});
export const APIsInstanceUniqeCurrencyId = axios.create({
    withCredentials: true
});

APIsInstance.interceptors.request.use(
    (config) => {
        const { currentCurrencyId: currencyId, userInfo } =
            store && store.getState().persistedReducer;

        // Set Bearer token for all requests
        if (userInfo?.accountInfo?.accessToken) {
            config.headers["Authorization"] = `Bearer ${userInfo.accountInfo.accessToken}`;
        }

        config.data = {
            ...config.data,
            currencyId
        };
        return config;
    },
    (error) => {
        const expectedErrors =
            error.response && error.response.status >= 400 && error.response.status < 500;
        if (!expectedErrors) {
        }
        return Promise.reject(error);
    }
);

APIsInstanceUniqeCurrencyId.interceptors.request.use(
    (config) => {
        const { userInfo } = store && store.getState().persistedReducer;

        // Set Bearer token for unique currency requests
        if (userInfo?.accountInfo?.accessToken) {
            config.headers["Authorization"] = `Bearer ${userInfo.accountInfo.accessToken}`;
        }

        return config;
    },
    (error) => {
        const expectedErrors =
            error.response && error.response.status >= 400 && error.response.status < 500;
        if (!expectedErrors) {
        }
        return Promise.reject(error);
    }
);

APIsInstance.interceptors.response.use(null, (error) => {
    const UNAUTHORIZED_CODES = [401, 403];
    const expectedErrors = error.response && UNAUTHORIZED_CODES.includes(error.response.status);
    if (expectedErrors) {
        store.dispatch(logOutUserAction());
        return Promise.reject("User is not authenticated!");
    }
    return Promise.reject(error);
});
